import { useNavigate } from 'react-router-dom';
import useWebData from '../../../hooks/useWebData';

const LocationTroubleErrorPage = () => {
    const { webData }: any = useWebData();
    const navigate = useNavigate();

    return (
        <section className="min-h-[calc(100vh-0px)] bg-[#F2F7FA] px-[1rem] py-[2rem] fixed inset-0 z-[100000]">
            <div
                className="bg-white w-full h-full border border-[#ff6926] rounded-lg flex items-center justify-center min-h-[calc(100vh-4rem)]"
                style={{
                    borderColor: webData?.websiteHeaderColor
                }}
            >
                <div className="max-w-screen-sm text-center">
                    <p className="mb-4 text-3xl tracking-tight font-bold md:text-4xl text-black">This share location link has expired</p>
                    <p className="mb-4 text-lg font-light text-gray-500">Please request a new share location link.</p>
                    <button
                        type="button"
                        className="text-white text-center bg-[#ff6926] font-medium rounded-lg text-sm px-5 py-2.5 mb-2"
                        style={{
                            backgroundColor: webData?.websiteHeaderColor
                        }}
                        onClick={() => {
                            navigate('/');
                        }}
                    >
                        Back To Home
                    </button>
                </div>
            </div>
        </section>
    )
}

export default LocationTroubleErrorPage